// Tailwind's `md` breakpoint. Screens at or above this get the desktop
// treatment; below it, the mobile one.
export const DESKTOP_BREAKPOINT = 768;

/**
 * Whether we are currently on a desktop-width screen.
 *
 * Read this when an interaction happens, not while rendering: the markup stays
 * identical on both form factors — layout is handled by Tailwind's `md:` classes —
 * and only the behaviour of a tap differs. Deciding at click time keeps a single
 * DOM tree, so nothing is mounted twice and no resize listener is needed.
 */
export function isDesktopViewport() {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT}px)`).matches;
}
